import type { QuestionSettings } from "@/types/question";
import { QuestionType } from "@/types/question";
import type { QuestionTypeOrChecklist } from "../../hooks/useQuestionForm";
import { DateSettings } from "./DateSettings";
import { FileSettings } from "./FileSettings";
import { NumberSettings } from "./NumberSettings";
import { TextSettings } from "./TextSettings";

type QuestionSettingsProps = {
	selectedType: QuestionTypeOrChecklist | null;
	settings: QuestionSettings;
	setSettings: (settings: QuestionSettings) => void;
	setError: (error: string | null) => void;
};

export const QuestionSettingsBlock = ({
	selectedType,
	settings,
	setSettings,
	setError,
}: QuestionSettingsProps) => {
	if (!selectedType) {
		return null;
	}

	if (selectedType === QuestionType.Text) {
		return <TextSettings setSettings={setSettings} settings={settings} />;
	}

	if (selectedType === QuestionType.Number) {
		return <NumberSettings setSettings={setSettings} settings={settings} />;
	}

	if (selectedType === QuestionType.Date) {
		return (
			<DateSettings
				setError={setError}
				setSettings={setSettings}
				settings={settings}
			/>
		);
	}

	if (selectedType === QuestionType.File) {
		return <FileSettings setSettings={setSettings} settings={settings} />;
	}

	return null;
};
